module.exports = __webpack_public_path__ + "ca3104cc6adc6d69139a25e79bcb40bf.png";